import * as React from 'react';

import { Modal } from 'antd';

import styles from '@app/components/UI/CustomModalMessage/Modal.module.scss';

interface CustomModalProps {
	modalVisible: boolean;
	setModalVisible: (e: boolean) => void;
	onCancel?: () => void;
	img?: string;
	title?: string;
	text?: string | JSX.Element;
	textButton?: string;
	buttonClass?: string;
	addClass?: string;
	defaultBtn?: boolean;
	closable?: boolean;
	maskClosable?: boolean;
	width?: number | string;
}

const CustomModalMessage: React.FC<CustomModalProps> = (props) => {
	const {
		modalVisible,
		setModalVisible,
		onCancel = () => setModalVisible(false),
		title = 'Service unavailable. Please try again later',
		textButton = 'Close',
		buttonClass = 'btn-teal-fill',
		img,
		text,
		children,
		addClass = '',
		defaultBtn = true,
		maskClosable = true,
		closable = false,
		width,
	} = props;

	return (
		<Modal
			wrapClassName={`${styles.modalWrap} ${addClass}`}
			open={modalVisible}
			onOk={() => setModalVisible(false)}
			onCancel={onCancel}
			centered
			closable={closable}
			maskClosable={maskClosable}
			width={width}
		>
			<div className={styles.header}>
				{img && (
					<img src={img} alt="img" className="modal__img" />
				)}
				<span
					className={styles.title}
					dangerouslySetInnerHTML={{
						__html: title,
					}}
				/>
			</div>
			<div>
				{text && (
					<p className={styles.text}>
						{props.text}
					</p>
				)}
				{children}
				{defaultBtn && (
					<button
						className={`btn ${buttonClass} modal__btn`}
						onClick={onCancel}
					>
						{textButton}
					</button>
				)}
			</div>
		</Modal>
	);
};

export default CustomModalMessage;
